import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import Index from './pages/IndexPage';
import Agenda from './pages/Agenda';
import Speakers from './pages/Speakers';
import Conference from './pages/Conference';
import NoRoute from './pages/NoRoute';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="Local"
      components={[
        { override: 'Index', component: Index },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'agenda', exact: true, path: '/agenda', component: Agenda },
        { name: 'speakers', exact: true, path: '/speakers', component: Speakers },
        { name: 'conference', exact: true, path: '/conference', component: Conference },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js